<template>
  <div class="card-info" v-if="isBlockExists">
    <div class="row">
      <div class="col-md-9 some-margin">
        <div class="card__prices">
          <div class="card-price" v-if="price" v-text="price" />
          <div class="card-oldprice" v-if="oldPrice" v-text="oldPrice" />
          <div class="card-oldprice lead-id-padding" v-text="`ID объекта: ${leadId}`" />
        </div>
      </div>
    </div>
    <div class="card-features" v-if="features.length">
      <div
        class="feature-info"
        v-for="feature of features"
        :key="feature.name"
        v-text="`${feature.name}: ${feature.value} ${feature.measure}`"
      />
    </div>

    <div class="card-description" v-if="description">
      <div class="txt-content-wr">
        <div class="txt-content content_block" v-html="description" :class="descriptionClass" />
        <div v-if="!this.isPrint" class="content_toggle ww-pointer" v-text="descriptionToggleText" @click="toggleDesctiption" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CardInfo',
  props: {
    description: {
      type: String,
    },
    features: {
      type: Array,
    },
    price: {
      type: String,
    },
    oldPrice: {
      type: String,
    },
    leadId: {
      type: Number,
    },
  },
  setup() {
    const descriptionHidden = ref(true)
  
    return {
      descriptionHidden,
    }
  },
  computed: {
    ...mapGetters(['isPrint']),
    isBlockExists() {
      return this.price || this.features.length || this.description
    },
    descriptionToggleText() {
      return this.descriptionHidden ? 'Читать подробнее' : 'Скрыть'
    },
    descriptionClass() {
      return { 
        hide: this.descriptionHidden && !this.isPrint,
      }
    },
  },
  methods: {
    toggleDesctiption() {
      this.descriptionHidden = !this.descriptionHidden
    },
  },
}
</script>

<style scoped>
.some-margin {
  margin-bottom: 30px;
}
.ww-pointer {
  cursor: pointer;
}
.lead-id-padding {
  padding-left: 50px;
}
</style>